import { FC } from 'react'
import Styles from './ControlGroupBox.module.scss'
import { FocusScope } from '@react-aria/focus'

const ControlGroupBox: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <div className={Styles.controlGroup}>
    <FocusScope>{children}</FocusScope>
  </div>
)

export { ControlGroupBox }
